import * as yup from 'yup';

// Individual validation schemas for reuse (no nullable - handled in validateField)
export const VALIDATION_SCHEMAS = {
  required: yup.string().required('This field is required'),
  email: yup.string().email('Email is not valid'),
  number: yup.string().matches(/[0-9]/, 'is not numeric'),
  zipcode: yup.string().matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Zipcode is in wrong format'),
  phone_number: yup.string().matches(/^(\+1|)[- ]?\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/, 'Phone number is in wrong format'),
  password: yup.string().required('Password is required')
};

// Helper to validate a single field with a single rule
// Returns array of errors (for backward compatibility) or undefined
export function validateField(ruleName, fieldName, value) {
  const schema = VALIDATION_SCHEMAS[ruleName];
  if (!schema) {
    console.warn(`Validation rule "${ruleName}" not found`);
    return undefined;
  }

  // Special handling: Skip format validation for empty values (unless it's 'required' or 'password')
  if (ruleName !== 'required' && ruleName !== 'password' && (value === '' || value === null || value === undefined)) {
    return undefined; // Empty value is OK for optional fields
  }

  // Special handling for 'required' - explicit empty check
  if (ruleName === 'required') {
    // For objects
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const hasValues = Object.keys(value).some(key => {
        const val = value[key];
        return val !== null && val !== undefined && val !== '';
      });

      if (!hasValues) {
        return ['This field is required'];
      }
      return undefined;
    }

    // For strings/primitives - check if empty
    if (value === '' || value === null || value === undefined) {
      return ['This field is required'];
    }
    return undefined;
  }

  try {
    schema.validateSync(value);
    return undefined;
  } catch (err) {
    return [err.message];
  }
}

// Helper to build a composite yup schema from validation rules object
// Format: { fieldName: ['rule1', 'rule2'], ... }
export function buildSchema(rules) {
  const shape = {};

  Object.keys(rules).forEach(fieldName => {
    const fieldRules = rules[fieldName];
    if (!Array.isArray(fieldRules) || fieldRules.length === 0) {
      return;
    }

    let schema = yup.string();

    fieldRules.forEach(ruleName => {
      const ruleSchema = VALIDATION_SCHEMAS[ruleName];
      if (ruleSchema) {
        schema = schema.concat(ruleSchema);
      }
    });

    shape[fieldName] = schema;
  });

  return yup.object().shape(shape);
}

// Legacy export for backward compatibility (deprecated)
export const VALIDATE_RULES = {
  required: {
    presence: {
      allowEmpty: false
    }
  },
  email: {
    email: true
  },
  number: {
    format: {
      pattern: "[0-9]",
      message: "is not numeric"
    }
  },
  zipcode: {
    format: {
      pattern: "^[0-9]{5}(?:-[0-9]{4})?$",
      message: 'is wrong zipcode format',
    }
  },
  phone_number: {
    format: {
      pattern: "^\(\\+1|)[- ]?\\(?(\\d{3})\\)?[- ]?(\\d{3})[- ]?(\\d{4})$",
      message: 'is wrong phone number format',
    }
  }
};
